// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Audit_main__J0QPY {
  display: grid;
  grid-template-columns: 72rem 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Audit_main__J0QPY {
    grid-template-columns: 56rem 1fr;
  }
}
@media only screen and (max-width: 43.75em) {
  .Audit_main__J0QPY {
    grid-template-columns: 100%;
  }
}
.Audit_main_nav__2bW-S {
  display: flex;
  justify-content: space-between;
  width: 34rem;
  flex-wrap: wrap;
  margin-top: 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Audit_main_nav__2bW-S > :not(:last-child) {
  margin-right: 1rem;
}
.Audit_main_nav_group__EN4Aj {
  position: relative;
}
.Audit_main_nav_more__-wFD5 {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Audit_main_nav_more__-wFD5 > :not(last-child) {
  margin-bottom: 1rem;
}
.Audit_main_nav_item__dKMlW {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Audit_main_nav_item_active__eHBR0 {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-admin-3);
  border-bottom: solid 2px var(--color-admin-3);
}
.Audit_main_nav_item__dKMlW:hover, .Audit_main_nav_item__dKMlW:focus, .Audit_main_nav_item__dKMlW:focus-visible, .Audit_main_nav_item__dKMlW:focus-within {
  font-weight: 700;
  color: var(--color-admin-3);
  border-bottom: solid 2px var(--color-admin-3);
}

.Audit_searchNav__AeyZY {
  display: flex;
  justify-content: center;
  margin: 3rem 0 0 20rem;
  gap: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .Audit_searchNav__AeyZY {
    flex-direction: column;
    align-items: center;
    margin: 0;
  }
}

.Audit_recent__y4PN\\+ {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  grid-column: 1/3;
  margin-top: 3rem;
}
.Audit_recent__title__XmU\\+P {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
}
.Audit_recent__title__active__7zNBA {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}
.Audit_recent__title__XmU\\+P > * {
  padding: 1rem 0;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
@media only screen and (max-width: 37.5em) {
  .Audit_recent__title__XmU\\+P > * {
    text-align: center;
    padding: 1rem;
  }
}
.Audit_recent__title__XmU\\+P > *:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}
.Audit_recent__title__XmU\\+P > :not(:last-child) {
  border-right: 1px solid var(--color-primary);
}
.Audit_recent__title__XmU\\+P > :first-child {
  border-radius: 1rem 0 0 1rem;
}
.Audit_recent__title__XmU\\+P > :last-child {
  border-radius: 0 1rem 1rem 0;
}

.Audit_date__nEnYk {
  background: var(--color-dark);
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: var(--default-font-small);
  line-height: 1.7rem;
  color: var(--color-white);
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.Audit_rt__main__DwfZV {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Audit_rt__content__KoeWs {
  width: 95%;
  cursor: pointer;
}
.Audit_rt__content__KoeWs > :not(:last-child) {
  margin-bottom: 3rem;
}

.Audit_paymentType__kEjTo {
  display: flex;
  flex-direction: row;
  gap: 2.9rem;
  margin-right: 2rem;
  margin-bottom: 2rem;
}

.Audit_beside__Ct7vs {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}

.Audit_successImg__hHPNM {
  height: 19rem;
}

.Audit_error__2XjWl {
  font-size: var(--default-font-small);
  color: var(--color-error);
  font-weight: 400;
}

.Audit_checks__mQq\\+s {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 38rem;
}
.Audit_checks__mQq\\+s > :not(:last-child) {
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/Audit.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AAFF;AAIE;EARF;IASI,gCAAA;EADF;AACF;AAGE;EAZF;IAaI,2BAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,0CAAA;EACA,4BAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,kBAAA;AADN;AAII;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAFN;AAIM;EACE,mBAAA;AAFR;AAMI;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAJN;AAMM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAJR;AAOM;EAIE,gBAAA;EACA,2BAAA;EACA,6CAAA;AARR;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAXF;AAaE;EANF;IAOI,sBAAA;IACA,mBAAA;IACA,SAAA;EAVF;AACF;;AAaA;EACE,aAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAVF;AAYE;EACE,aAAA;EACA,WAAA;EACA,qCAAA;EACA,mBAAA;EACA,wCAAA;EACA,oCAAA;AAVJ;AAYI;EACE,mCAAA;EACA,yBAAA;EACA,gBAAA;AAVN;AAaI;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAXN;AAaM;EANF;IAOI,kBAAA;IACA,aAAA;EAVN;AACF;AAYM;EACE,mCAAA;EACA,yBAAA;EACA,gBAAA;AAVR;AAcI;EACE,4CAAA;AAZN;AAeI;EACE,4BAAA;AAbN;AAgBI;EACE,4BAAA;AAdN;;AAqBA;EACE,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAlBF;;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,UAAA;EACA,eAAA;AAtBJ;AAwBI;EACE,mBAAA;AAtBN;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,aAAA;AA1BF;;AA+BA;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AA5BF;AA8BE;EACE,kBAAA;AA5BJ","sourcesContent":["// styles for BusinessInsightCards and QuickCards//\n@import \"../variables/breakpoints\";\n\n.main {\n  display: grid;\n  grid-template-columns: 72rem 1fr;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 56rem 1fr;\n  }\n\n  @media only screen and (max-width: $bp-700) {\n    grid-template-columns: 100%;\n  }\n\n  &_nav {\n    display: flex;\n    justify-content: space-between;\n    width: 34rem;\n    flex-wrap: wrap;\n    margin-top: 2rem;\n    background-color: var(--color-white);\n    border-bottom: solid 1px var(--color-dark);\n    border-radius: 1rem 1rem 0 0;\n\n    & > :not(:last-child) {\n      margin-right: 1rem;\n    }\n\n    &_group {\n      position: relative;\n    }\n\n    &_more {\n      position: absolute;\n      right: 0;\n      top: 75%;\n      background-color: var(--color-white);\n      padding: 1.5rem;\n      border-radius: 1rem;\n      box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n      z-index: 5;\n\n      & > :not(last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      font-size: var(--default-font-small);\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        box-sizing: border-box;\n        font-size: var(--default-font-small);\n        font-weight: 700;\n        color: var(--color-admin-3);\n        border-bottom: solid 2px var(--color-admin-3);\n      }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n        color: var(--color-admin-3);\n        border-bottom: solid 2px var(--color-admin-3);\n      }\n    }\n  }\n}\n\n.searchNav {\n  display: flex;\n  justify-content: center;\n  margin: 3rem 0 0 20rem;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-700) {\n    flex-direction: column;\n    align-items: center;\n    margin: 0;\n  }\n}\n\n.recent {\n  display: grid;\n  grid-template-columns: 1fr;\n  width: 100%;\n  grid-column: 1/3;\n  margin-top: 3rem;\n\n  &__title {\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(3, 1fr);\n    border-radius: 1rem;\n    background-color: var(--color-primary-3);\n    font-size: var(--default-font-small);\n\n    &__active {\n      background-color: var(--color-dark);\n      color: var(--color-white);\n      font-weight: 700;\n    }\n\n    & > * {\n      padding: 1rem 0;\n      text-align: center;\n      box-sizing: border-box;\n      cursor: pointer;\n\n      @media only screen and (max-width: $bp-600) {\n        text-align: center;\n        padding: 1rem;\n      }\n\n      &:hover {\n        background-color: var(--color-dark);\n        color: var(--color-white);\n        font-weight: 700;\n      }\n    }\n\n    & > :not(:last-child) {\n      border-right: 1px solid var(--color-primary);\n    }\n\n    & > :first-child {\n      border-radius: 1rem 0 0 1rem;\n    }\n\n    & > :last-child {\n      border-radius: 0 1rem 1rem 0;\n    }\n  }\n}\n\n// Transaction Date //\n\n.date {\n  background: var(--color-dark);\n  border-radius: 1rem;\n  padding: 1rem;\n  text-align: center;\n  font-weight: 700;\n  font-size: var(--default-font-small);\n  line-height: 1.7rem;\n  color: var(--color-white);\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n// Recent Transactions //\n\n.rt {\n  &__main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__content {\n    width: 95%;\n    cursor: pointer;\n\n    & > :not(:last-child) {\n      margin-bottom: 3rem;\n    }\n  }\n}\n\n// Add Payment Type Styles //\n\n.paymentType {\n  display: flex;\n  flex-direction: row;\n  gap: 2.9rem;\n  margin-right: 2rem;\n  margin-bottom: 2rem;\n}\n\n.beside {\n  display: flex;\n  justify-content: space-between;\n  width: 38rem;\n}\n\n.successImg {\n  height: 19rem;\n}\n\n//Errors\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  font-weight: 400;\n}\n\n.checks {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem 0 2rem 0;\n  width: 38rem;\n\n  & > :not(:last-child) {\n    margin-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Audit_main__J0QPY`,
	"main_nav": `Audit_main_nav__2bW-S`,
	"main_nav_group": `Audit_main_nav_group__EN4Aj`,
	"main_nav_more": `Audit_main_nav_more__-wFD5`,
	"main_nav_item": `Audit_main_nav_item__dKMlW`,
	"main_nav_item_active": `Audit_main_nav_item_active__eHBR0`,
	"searchNav": `Audit_searchNav__AeyZY`,
	"recent": `Audit_recent__y4PN+`,
	"recent__title": `Audit_recent__title__XmU+P`,
	"recent__title__active": `Audit_recent__title__active__7zNBA`,
	"date": `Audit_date__nEnYk`,
	"rt__main": `Audit_rt__main__DwfZV`,
	"rt__content": `Audit_rt__content__KoeWs`,
	"paymentType": `Audit_paymentType__kEjTo`,
	"beside": `Audit_beside__Ct7vs`,
	"successImg": `Audit_successImg__hHPNM`,
	"error": `Audit_error__2XjWl`,
	"checks": `Audit_checks__mQq+s`
};
export default ___CSS_LOADER_EXPORT___;
